// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yFgb","type":"styles_type__9sPNA","choices":"styles_choices__IqPtc"};